import { Dispatch, SetStateAction } from "react";
import { Checkbox as CheckboxShared } from "@src/shared/src";

interface CheckBoxProps {
  id: string;
  size?: "small" | "medium" | "large";
  name: string;
  value: string;
  setValue: Dispatch<SetStateAction<string>> | ((val: string) => void);
  checked: boolean;
  onClick?: (e: React.MouseEvent) => void;
  disabled?: boolean;
  labelComponent?: React.ReactNode;
  appearance?: "default" | "switch";
}

const Checkbox = ({
  id,
  size = "medium",
  name,
  value,
  setValue,
  checked,
  onClick = () => {},
  disabled = false,
  labelComponent,
  appearance = "default",
}: CheckBoxProps) => {
  return (
    <>
      {/* <div
        className={` ${appearance === "switch" ? "input-switch-wrap" : "input-checkbox-wrap"} ${size}`}
      >
        <input
          id={id}
          type="checkbox"
          name={name}
          className={`${appearance === "switch" ? "input-switch" : "input-checkbox"} only-sr`}
          value={value}
          checked={checked}
          onChange={() => setValue(value)}
          onClick={(e) => onClick(e)}
          disabled={disabled}
        />
        <label
          // htmlFor={id} // input 영역으로 스크롤 이동되는 현상 방지하기 위해 htmlFor 대신 onClick 사용
          onClick={(e) => {
            e.preventDefault();
            setValue(value);
          }}
        ></label>
      </div>
      {labelComponent && (
        <label
          className={`${appearance === "switch" ? "input-switch-label" : "input-checkbox-label"} `}
          // htmlFor={id} // input 영역으로 스크롤 이동되는 현상 방지하기 위해 htmlFor 대신 onClick 사용
          onClick={(e) => {
            e.preventDefault();
            setValue(value);
          }}
        >
          {labelComponent}
        </label>
      )} */}
      <CheckboxShared
        className={appearance === "switch" ? "input-switch-wrap" : "input-checkbox-wrap"}
        id={id}
        size={size}
        name={name}
        value={value}
        setValue={setValue}
        checked={checked}
        onClick={onClick}
        disabled={disabled}
        labelComponent={labelComponent}
        appearance={appearance}
      />
    </>
  );
};

export default Checkbox;
